import { combineEpics } from 'redux-observable';

import { getBankAccountLinkingWidgetUrlEpic } from './get-bank-account-linking-widget-url.epic';
import { notifyBankAccountConnectedEpic } from './notify-bank-account-connected.epic';

const bankAccountLinkingEpics = combineEpics(getBankAccountLinkingWidgetUrlEpic, notifyBankAccountConnectedEpic);

export { bankAccountLinkingEpics };
